var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"iframeEditor",style:('width:100%;border:0;height:100%'),attrs:{"src":"https://home-editor.mocoplex.com/editor.html"}})}
var staticRenderFns = []

export { render, staticRenderFns }